"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ProgressIndication = exports.ProgressIndicationState = void 0;
var ProgressIndicationState;
(function (ProgressIndicationState) {
    ProgressIndicationState[ProgressIndicationState["Unknown"] = 0] = "Unknown";
    ProgressIndicationState[ProgressIndicationState["Allowed"] = 1] = "Allowed";
    ProgressIndicationState[ProgressIndicationState["Forbidden"] = 2] = "Forbidden";
})(ProgressIndicationState = exports.ProgressIndicationState || (exports.ProgressIndicationState = {}));
var ProgressIndication = (function () {
    function ProgressIndication(progressService) {
        if (progressService === void 0) { progressService = null; }
        this.progressLimit = 30;
        this.progressRange = 1;
        this.progressService = progressService;
    }
    ProgressIndication.prototype.begin = function (displayName, minProgress, maxProgress, currentProgress) {
        this.displayName = displayName;
        this.minProgress = minProgress;
        this.progressRange = Math.max(1, maxProgress - minProgress);
        this.normalizedProgress = this.calculateProgress(currentProgress);
        this.indicationTime = new Date();
        this.indicationState = ProgressIndicationState.Unknown;
    };
    ProgressIndication.prototype.setProgress = function (currentProgress) {
        var progress = this.calculateProgress(currentProgress);
        if (this.indicationState == ProgressIndicationState.Unknown) {
            var now = new Date();
            if (now.valueOf() - this.indicationTime.valueOf() >= ProgressIndication.progressShowDelay.valueOf()) {
                if (progress <= this.progressLimit) {
                    this.indicationState = ProgressIndicationState.Allowed;
                    this.normalizedProgress = progress;
                    this.beginIndicationCore();
                    this.indicateProgressCore();
                    this.indicationTime = now;
                }
                else
                    this.indicationState = ProgressIndicationState.Forbidden;
            }
        }
        if (progress != this.normalizedProgress) {
            this.normalizedProgress = progress;
            if (this.indicationState == ProgressIndicationState.Allowed) {
                var now = new Date();
                if (now.valueOf() - this.indicationTime.valueOf() >= ProgressIndication.minIndicationInterval.valueOf() ||
                    this.normalizedProgress == 100) {
                    this.indicateProgressCore();
                    this.indicationTime = now;
                }
            }
        }
    };
    ProgressIndication.prototype.end = function () {
        if (this.progressService)
            this.progressService.end();
    };
    ProgressIndication.prototype.calculateProgress = function (value) {
        return 100 * (value - this.minProgress) / this.progressRange;
    };
    ProgressIndication.prototype.beginIndicationCore = function () {
        if (this.progressService)
            this.progressService.begin(this.displayName, 0, 100, this.normalizedProgress);
    };
    ProgressIndication.prototype.indicateProgressCore = function () {
        if (this.progressService)
            this.progressService.setProgress(this.normalizedProgress);
    };
    ProgressIndication.progressShowDelay = new Date(0, 0, 0, 0, 0, 0, 500);
    ProgressIndication.minIndicationInterval = new Date(0, 0, 0, 0, 0, 0, 50);
    return ProgressIndication;
}());
exports.ProgressIndication = ProgressIndication;
